import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Modal } from 'react-bootstrap'
import moment from 'moment'
import { endOfDay } from "date-fns"
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { useTranslation } from 'react-i18next'

import { tableExportOptions } from '../../../helpers/table'

import { formatTimestamp } from '../../../helpers/tablesFuncHelpers'
import DateDropdown from '../../../dump/menuComponents/DateDropdown'

const ModalMovementLog = (props) => {
	const { t } = useTranslation('translation', { keyPrefix: 'modals.modalMovementLog' });
	const { data, loaderModal, getMovementLogData } = props;
	const { reportDates } = data;
	const { startDate, endDate } = reportDates;

	const [start_date, setStart_date] = useState(moment(data.first_entry || startDate).format("YYYYMMDD"));
	const [end_date, setEnd_date] = useState(moment(data.last_exit || endDate).format("YYYYMMDD"));
	const [tableData, setTableData] = useState(data.data || []);

	useEffect(() => {
		setTableData(data.data || []);
	}, [data.data])

	const changeDate = (selected_start_date, selected_end_date) => {
		const new_start_date = moment(selected_start_date).format('YYYYMMDD');
		const new_end_date = moment(selected_end_date).format('YYYYMMDD');
		getMovementLogData(data, new_start_date, new_end_date);
		setStart_date(new_start_date);
		setEnd_date(new_end_date);
	}

	const formatCSVFileName = () => {
		const timeframe = '_' + moment(start_date).format('M-D-YY') + (start_date === end_date ? '' : '--' + moment(end_date).format('M-D-YY'));
		return t('CSVFileName') + data.vehicle_name.toLowerCase().replaceAll(' ', '_') + timeframe + '.csv';
	}

	return (
		<Modal
			size='xl'
			show
			onHide={props.onHide}
			aria-labelledby="contained-modal-title-lg"
			dialogClassName="modal-movement-lg"
		>
			<Modal.Header closeButton>
				<Modal.Title>{`${t('titleMovementLog')} - ${data.vehicle_name}`}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="date-container">
					<span className="titleDateRange">{t('titleDateRange')}</span>
					<DateDropdown
						start_date={start_date}
						end_date={end_date}
						maxDate={endOfDay(new Date())}
						onSelectDate={changeDate}
					/>
				</div>
				<div className="header-info">
					<p>{t('labelDriverID')} <span>{data.driver_id || 'N/A'}</span></p>
					<p>{t('labelDeviceID')} <span>{data.device_id || 'N/A'}</span></p>
				</div>
				<div className="modal-movementLog-table">
					<BootstrapTable
						data={tableData}
						{...tableExportOptions}
						csvFileName={formatCSVFileName}
					>
						<TableHeaderColumn
							isKey
							width="20%"
							dataField="entry_time"
							dataFormat={(cell) => formatTimestamp(cell)}
							csvHeader={t('titleEntryTime')}
						>
							{t('titleEntryTime')}
						</TableHeaderColumn>
						<TableHeaderColumn
							width="20%"
							dataField="entry_zone"
							tdStyle={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
							csvHeader={t('titleEntryZone')}
						>
							{t('titleEntryZone')}
						</TableHeaderColumn>
						<TableHeaderColumn
							width="20%"
							dataField="exit_time"
							dataFormat={(cell) => formatTimestamp(cell)}
							csvHeader={t('titleExitTime')}
						>
							{t('titleExitTime')}
						</TableHeaderColumn>
						<TableHeaderColumn
							width="20%"
							dataField="exit_zone"
							dataFormat={(cell) => cell || '-'}
							tdStyle={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
							csvHeader={t('titleExitZone')}
						>
							{t('titleExitZone')}
						</TableHeaderColumn>
						<TableHeaderColumn
							width="20%"
							dataField="duration"
							dataFormat={(cell) => {
								return cell ? moment.duration(cell, 'seconds').format('h:mm:ss') : t('inZone')
							}}
							csvHeader={t('titleDurationInTheZone')}
						>
							{t('titleDurationInTheZone')}
						</TableHeaderColumn>
					</BootstrapTable>
				</div>
			</Modal.Body>
			{loaderModal}
		</Modal>
	)
}

export default connect(
	state => ({
		loaderModal: state.loader.loaderModal
	}),
	dispatch => ({
		toggleLoaderModal: (show) => {
			dispatch({ type: 'TOGGLE_LOADER_MODAL', payload: show });
		}
	})
)(ModalMovementLog);
